import { DocumentData } from '@matech/thebigpos-sdk'
import { VAULT_BUCKETS } from './constants'
import { MediaFileProps } from '../../../../components/MediaLibrary/types'

export const sortLoanDocumentFolders = (folders: string[]) => {
	return folders.sort((a, b) => {
		if (VAULT_BUCKETS.includes(a) && !VAULT_BUCKETS.includes(b)) {
			return -1 // a comes first
		}
		if (!VAULT_BUCKETS.includes(a) && VAULT_BUCKETS.includes(b)) {
			return 1 // b comes first
		}
		return (a ?? '').localeCompare(b ?? '') // Sort alphabetically
	})
}

export const getLoanDocumentFolders = (
	loanDocuments: DocumentData[],
	defaultFolder: string
) => {
	if (!loanDocuments || loanDocuments.length === 0) {
		return []
	}
	const folders = [
		...new Set(
			loanDocuments.map(
				(row) => row.documentBucketTitle ?? defaultFolder
			)
		),
	]

	return sortLoanDocumentFolders(folders)
}

export const sortLoanDocuments = (
	data: MediaFileProps[],
	sortBy: keyof MediaFileProps,
	direction: 'asc' | 'desc'
) => {
	return data.sort((a, b) => {
		if (sortBy === 'createdAt') {
			const dateA = a[sortBy] ? new Date(a[sortBy]).getTime() : 0
			const dateB = b[sortBy] ? new Date(b[sortBy]).getTime() : 0

			return direction === 'asc' ? dateA - dateB : dateB - dateA
		}

		const valueA = (a[sortBy] ?? '').toString().toLowerCase()
		const valueB = (b[sortBy] ?? '').toString().toLowerCase()

		if (direction === 'asc') {
			if (valueA > valueB) return 1
			if (valueA < valueB) return -1
			return 0
		}

		if (valueA < valueB) return 1
		if (valueA > valueB) return -1
		return 0
	})
}
